import { createApiHandler } from './handler';

const quotes = {
  apiClient: null,
  path: '/franchises/quotes',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getByBranch(branchId, params = []) {
    const queryParams = new URLSearchParams();
    params.forEach((param) => {
      if (param.name && param.value) {
        queryParams.append(param.name, param.value);
      }
    });
    const response = await this.apiClient.get(`${this.path}/branch/${branchId}?${queryParams.toString()}`);
    return response.data;
  },

  async getQuoteRequests() {
    try {
      const response = await this.apiClient.get(`${this.path}/requests`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getQuoteRequestById(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/requests/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async calculateShippingPrice(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/calculate-shipping-price`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async changeDeliveryMode(id, payload) {
    try {
      const response = await this.apiClient.post(`${this.path}/change-delivery-mode/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

};

export default quotes;
